import {
  type LabelData,
  getPredictionMarketLabelQueries,
} from "@roman/shared/hooks/PredictionMarket/usePredictionMarketLabels";
import { cn } from "@roman/shared/utils";

interface LabelSelectorProps {
  labels: LabelData[];
  selectedLabel: LabelData;
  onLabelSelect: (label: LabelData) => void;
}

export const LabelSelector = ({ labels, selectedLabel, onLabelSelect }: LabelSelectorProps) => {
  return (
    <div className="overflow-hidden relative">
      <div className="flex w-full h-[52px] overflow-x-scroll hide-scrollbar">
        {labels.map((label) => {
          const { displayText } = getPredictionMarketLabelQueries(label);
          const isSelectedLabel = selectedLabel === label;

          return (
            <div key={label} className="flex-shrink-0 flex border-solid relative">
              <div
                className={cn(
                  "flex items-center hover:cursor-pointer justify-center text-base  px-4 min-w-[64px]",
                  isSelectedLabel
                    ? "text-[#4B57FF] font-bold text-[18px] height-[24px]"
                    : "text-gray text-[16px] height-[16px] font-medium",
                )}
                onClick={() => onLabelSelect(label)}
              >
                <p className="text-center">
                  {displayText.split("\n").flatMap((line) => (
                    <span key={line}>
                      {line === "人気" ? "🔥人気" : line}
                      <wbr />
                    </span>
                  ))}
                </p>
              </div>
              <div
                className={cn(
                  "absolute bottom-0 left-0 right-0 h-[4px] px-[4px] opacity-0 z-10",
                  isSelectedLabel && "opacity-100",
                )}
              >
                <span className="block h-full bg-[#4B57FF] rounded-full z-50" />
              </div>
            </div>
          );
        })}
      </div>

      <div className={cn("absolute bottom-0 left-0 right-0 h-[4px] z-9 w-full px-[4px]")}>
        <span className="block h-full bg-[#E7EBEE] rounded-full" />
      </div>
    </div>
  );
};
